(function (algolia, instantsearch) {
    var collectionPage =
        Boolean(algolia.is_collection_results_page) &&
        Boolean(algolia.config.instant_search_enabled_on_collection);
    console.log("instant search");

    if (
        (!algolia.full_results && !collectionPage) ||
        !algolia.config.instant_search_enabled
    ) {
        return;
    }

    var _ = algolia._;
    var $ = algolia.jQuery;

    /**
     * Array which will contain all filters to be applied while initiating the
     * search API call.
     */
    var searchFilters = [];

    // Filters for collection page
    var collectionFacetFilter = null;
    var collectionRulesContextValue = null;
    if (collectionPage) {
        var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
        var handle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

        if (algolia.config.collection_id_indexing) {
            collectionFacetFilter = algolia.current_collection_id ?
                'collection_ids:"' + algolia.current_collection_id + '"' :
                null;
        } else {
            collectionFacetFilter = 'collections:"' + handle + '"';
        }

        // Add the collection filter to the list of search filters
        searchFilters.push(collectionFacetFilter);

        collectionRulesContextValue = algolia.config.collection_id_query_rules ?
            algolia.current_collection_id :
            handle;
    }

    // Filters for stock policy
    var stockPolicyFilter = null;
    if (algolia.config.stock_policy) {
        if (algolia.config.stock_policy == 'allow') {
            /**
             * For 'allow', we don't need to add any filter as we want to continue
             * displaying all out of stock items.
             */
        } else if (algolia.config.stock_policy == 'deny') {
            // For 'deny' we will filter out all items based on inventory quantity
            stockPolicyFilter = 'inventory_quantity > 0';
        } else if (algolia.config.stock_policy == 'continue') {
            /**
             * For 'continue' we will filter on `inventory_available` attribute whose
             * value is dependent on:
             * `inventory_quantity > 0 OR inventory_policy == 'continue'`
             */
            stockPolicyFilter = 'inventory_available:true';
        }

        // Add the stock policy filter to the list of search filters
        if (stockPolicyFilter) {
            searchFilters.push(stockPolicyFilter);
        }
    }

    var results_selector = collectionPage ?
        algolia.config.collection_css_selector :
        algolia.config.results_selector;

    var activeSortOrders =
        collectionPage && algolia.collectionSortOrders ?
        algolia.collectionSortOrders :
        algolia.sortOrders;

    results_selector += ', .algolia-shopify-instantsearch';

    var $hiding = $(
        '<style>' + results_selector + ' { visibility: hidden }</style>'
    );
    $hiding.appendTo($('head'));

    var instant = {
        colors: algolia.config.colors,
        distinct: Boolean(algolia.config.show_products),
        facets: {
            hidden: collectionPage && algolia.collectionHiddenFacets ?
                algolia.collectionHiddenFacets :
                algolia.hiddenFacets,
            shown: collectionPage && algolia.collectionShownFacets ?
                algolia.collectionShownFacets :
                algolia.shownFacets,
            list: collectionPage && algolia.collectionFacets ?
                algolia.collectionFacets :
                algolia.facets,
            widgets: collectionPage && algolia.collectionFacetsWidgets ?
                algolia.collectionFacetsWidgets :
                algolia.facetsWidgets,
        },
        hitsPerPage: collectionPage && algolia.config.collections_full_results_hits_per_page ?
            algolia.config.collections_full_results_hits_per_page :
            algolia.config.products_full_results_hits_per_page,
        poweredBy: algolia.config.powered_by,
        search: instantsearch({
            appId: algolia.config.app_id,
            apiKey: algolia.config.search_api_key,
            indexName: '' + algolia.config.index_prefix + 'products',
            searchParameters: {
                clickAnalytics: true,
            },
            urlSync: {},
            searchFunction: function (searchFunctionHelper) {
                // Set query parameters here because they're not kept when someone
                // presses the Back button if set in the `init` function of a custom widget
                var helper = instant.search.helper;
                var page = helper.getPage();
                helper.setQueryParameter(
                    'highlightPreTag',
                    '<span class="ais-highlight">'
                );
                helper.setQueryParameter('highlightPostTag', '</span>');
                if (instant.distinct) {
                    helper.setQueryParameter('distinct', true);
                }

                if (localStorage.getItem('skus')) {
                    var skus = JSON.parse(localStorage.getItem('skus'));
                    helper.setQueryParameter('filters', skus.map(function (s) {
                        return 'sku:' + s;
                    }).join(' OR '));
                    // localStorage.removeItem('skus');
                }

                // Assign any required filters
                if (searchFilters.length) {
                    helper.setQueryParameter('filters', searchFilters.join(' AND '));
                }

                // Collection page features
                if (collectionPage) {
                    // Collection page merchandising:
                    // send rulesContext for promoted results only if no filters active
                    var currentState = helper.getState();
                    if (
                        _.keys(currentState.facetsRefinements).length === 0 &&
                        _.keys(currentState.numericRefinements).length === 0 &&
                        _.keys(currentState.disjunctiveFacetsRefinements).length === 0 &&
                        Number(page) === 0
                    ) {
                        // If we are on a collection page, `collectionRulesContextValue` is defined
                        if (collectionRulesContextValue) {
                            helper.setQueryParameter('ruleContexts', [
                                collectionRulesContextValue.toString(),
                            ]);
                        }
                    } else {
                        helper.setQueryParameter('ruleContexts', []);
                    }
                }

                helper.setPage(page);
                searchFunctionHelper.search();
            },
        }),
        selector: results_selector + ', .algolia-shopify-instantsearch',
        // sortOrders: activeSortOrders,
        sortOrders: _.sortBy(algolia.sortOrders, function (so) {
            so.label === 'Most available' ? -1 : 1
        }),
        storeName: algolia.storeName,
        templates: {
            currentItem: algolia.getTemplate(
                'instant_search_current_refined_values_item'
            ),
            empty: algolia.getTemplate('instant_search_no_result'),
            page: algolia.compileTemplate('instant_search'),
            product: algolia.getTemplate('instant_search_product'),
            stats: algolia.getTemplate('instant_search_stats'),
            style: algolia.compileTemplate('instant_search.css'),
        },
    };

    algolia.instantsearch = instant;

    if (instant.poweredBy) {
        // eslint-disable-next-line no-console
        console.log('Algolia: Instant-Search');
    }

    function readjust() {
        var width = instant.$results.outerWidth();

        var suffix = 'lg';
        if (width < 400) suffix = 'xs';
        else if (width < 800) suffix = 'sm';
        else if (width < 1200) suffix = 'md';

        instant.$results
            .removeClass('ais-results-size-xs')
            .removeClass('ais-results-size-sm')
            .removeClass('ais-results-size-md')
            .removeClass('ais-results-size-lg')
            .addClass('ais-results-size-' + suffix);
    }

    // Bind helpers
    _.forEach(
        Object.assign({}, algolia.helpers, algolia.translation_helpers),
        function (helper, name) {
            instant.search.templatesConfig.helpers[name] = helper;
        }
    );
    instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

    algolia.appendStyle(
        algolia.render(instant.templates.style, {
            distinct: instant.distinct,
            colors: instant.colors,
        })
    );

    $(document).ready(function () {
        if (
            collectionPage &&
            $(algolia.config.collection_css_selector).length === 0
        ) {
            throw new Error(
                'Instant search CSS selector for collection page is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
            );
        } else if ($(algolia.config.results_selector).length === 0) {
            throw new Error(
                'Instant search CSS selector is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
            );
        }

        instant.$results = $(instant.selector);

        instant.$results.html(
            algolia.render(instant.templates.page, {
                facets: instant.facets.list,
                storeName: instant.storeName,
                translations: algolia.translations,
                multipleSortOrders: activeSortOrders.length > 1
            })
        );

        readjust();

        $(window).resize(function () {
            readjust();
        });

        // Mobile facets display
        instant.search.addWidget({
            init: function () {
                var $button = $('.ais-facets-button');
                $button.on('click', function () {
                    var $facets = $('.ais-facets');

                    if ($facets.hasClass('ais-facets__shown')) {
                        $button.text('Show filters');
                        $facets.removeClass('ais-facets__shown');
                    } else {
                        $button.text('Hide filters');
                        $facets.addClass('ais-facets__shown');
                    }
                });
            },
        });

        // Inventory in stock. out of stock
        instant.search.addWidget({
            init: function (opts) {

                var helper = opts.helper;
                // In stock
                $('.algolia-in-stock').on('click', function () {
                    var page = helper.getPage();

                    if ($('.algolia-out-of-stock').hasClass('ais-facet--active')) { // Already selected, removing the filter
                        $('.algolia-out-of-stock').removeClass('ais-facet--active');
                    }
                    if ($(this).hasClass('ais-facet--active')) { // Already selected
                        $(this).removeClass('ais-facet--active');
                        helper.removeNumericRefinement('inventory_quantity');
                        helper.setQueryParameter('filters', ''); 
                    } else {
                        $(this).addClass('ais-facet--active');
                        helper.removeNumericRefinement('inventory_quantity');
                        helper.addNumericRefinement('inventory_quantity', '>', '0');
                        helper.setQueryParameter('filters', `inventory_available:true`);
                    }

                    helper.setPage(page);
                    helper.search();
                });

                // Out of stock
                $('.algolia-out-of-stock').on('click', function () {
                    var page = helper.getPage();

                    if ($('.algolia-in-stock').hasClass('ais-facet--active')) { // Already selected, removing the filter
                        $('.algolia-in-stock').removeClass('ais-facet--active');
                    }
                    if ($(this).hasClass('ais-facet--active')) { // Already selected, removing the filter
                        $(this).removeClass('ais-facet--active');
                        helper.removeNumericRefinement('inventory_quantity');
                        helper.setQueryParameter('filters', ''); 
                    } else {
                        $(this).addClass('ais-facet--active');
                        helper.removeNumericRefinement('inventory_quantity');
                        helper.addNumericRefinement('inventory_quantity', '<=', '0');
                        helper.setQueryParameter('filters', `inventory_available:false`);
                    }

                    helper.setPage(page);
                    helper.search();
                });
            }
        });
        // instant.search.addWidget(
        //     instantsearch.widgets.refinementList({
        //         container: '.refinement-list',
        //         attributes: 'brands',
        //     })
        // );
        //Heirarchy Menu
        instant.search.addWidget(
            instantsearch.widgets.hierarchicalMenu({
                container: '.hierarchical-categories-menu',
                attributes: ['named_tags.level_1', 'named_tags.level_2', 'named_tags.level_3', 'named_tags.level_4', 'named_tags.level_5', 'named_tags.level_6', 'named_tags.level_7', 'named_tags.level_8', 'named_tags.level_9', 'named_tags.level_10'],
                autoHideContainer: false,
                showParentLevel: true,
                limit: 100,
                // templates: {
                //     item(data) {
                //         console.log('data.cssClasses', data.cssClasses);
                //         return `
                //             <a class="${data.cssClasses.link}" href="${data.url}">
                //             <span class="${data.cssClasses.label}">${data.name}</span>
                //             <span class="${data.cssClasses.count}">
                //                 (${data.count.toLocaleString()})
                //             </span>
                //             </a>
                //         `;
                //     },
                // }
                templates: {
                    item: function item(data) {
                        return "\n<a class=\"".concat(data.cssClasses.link, "\" href=\"").concat(data.url, "\">\n<span class=\"").concat(data.cssClasses.label, "\">").concat(data.name, "</span>\n<span class=\"").concat(data.cssClasses.count, "\">\n(").concat(data.count.toLocaleString(), ")\n</span>\n</a>\n");
                    }
                },

            })
        );


        // search by sku
        instant.search.addWidget({
            init: function (opts) {
                window.skus.registerListener(function (value) {
                    // console.log('value', value)
                    var helper = opts.helper;
                    helper.setQueryParameter('filters', value.map(function (s) {
                        return 'sku:' + s;
                    }).join(' OR '));
                    helper.search();
                })
            }
        });

        // Search input
        instant.search.addWidget(
            instantsearch.widgets.searchBox({
                container: '.container .search-page .input-wrap',
                placeholder: algolia.translations.searchForProduct,
                poweredBy: false,
                showReset: true,
            })
        );

        // Logo & clear
        instant.search.addWidget({
            init: function (opts) {
                if (!instant.poweredBy) {
                    $('.ais-algolia-icon').hide();
                }
                $('.ais-clear-input-icon').on('click', function () {
                    opts.helper.setQuery('').search();
                    $('.ais-search-box--input')
                        .val('')
                        .focus();
                });
            },
            render: function (opts) {
                if (!opts.state.query) {
                    if (instant.poweredBy) {
                        $('.ais-algolia-icon').show();
                    }
                    $('.ais-clear-input-icon').hide();
                    //TODO
                    /*console.log('hide')*/
                } else {
                    /*console.log('show')*/
                    $('.ais-clear-input-icon').show();
                    $('.ais-algolia-icon').hide();
                }
            },
        });

        // Stats
        instant.search.addWidget(
            instantsearch.widgets.stats({
                container: '.ais-stats-container',
                templates: {
                    body: instant.templates.stats,
                },
                transformData: {
                    body: function (data) {
                        return Object.assign({}, data, {
                            processingTimeS: data.processingTimeMS / 1000,
                            start: data.page * data.hitsPerPage + 1,
                            end: Math.min((data.page + 1) * data.hitsPerPage, data.nbHits),
                            translations: algolia.translations,
                        });
                    },
                },
            })
        );

        /*instant.search.addWidget(
            instantsearch.widgets.stats({
                container: '.show-custom-pagination',
                templates: {
                    body: "Page [[page]] of [[nbPages]]",
                },
                transformData: {
                    body: function (data) {
                        return Object.assign({}, data, {
                            page: data.page + 1,
                            nbPages: data.nbPages,
                            translations: algolia.translations,
                        });
                    },
                },
            })
        );*/

        // Sort orders
        if (activeSortOrders.length > 1) {
            instant.search.addWidget(
                instantsearch.widgets.sortBySelector({
                    container: '.ais-sort-orders-container',
                    indices: instant.sortOrders,
                })
            );
        }


        // Change display
        instant.search.addWidget({
            init: function () {
                $('.ais-search-header').on(
                    'click',
                    '.ais-change-display-block',
                    function () {
                        $(
                            '.ais-change-display-block:not(.ais-change-display-selected)'
                        ).addClass('ais-change-display-selected');
                        $(
                            '.ais-change-display-list.ais-change-display-selected'
                        ).removeClass('ais-change-display-selected');
                        $('.ais-results-as-list')
                            .removeClass('ais-results-as-list')
                            .addClass('ais-results-as-block');
                    }
                );
                $('.ais-search-header').on(
                    'click',
                    '.ais-change-display-list',
                    function () {
                        $(
                            '.ais-change-display-list:not(.ais-change-display-selected)'
                        ).addClass('ais-change-display-selected');
                        $(
                            '.ais-change-display-block.ais-change-display-selected'
                        ).removeClass('ais-change-display-selected');
                        $('.ais-results-as-block')
                            .removeClass('ais-results-as-block')
                            .addClass('ais-results-as-list');
                    }
                );
            },
        });
        // console.log('instant', instant)
        // console.log('instant', instantsearch)
        // Hidden facets
        var list = _.map(instant.facets.hidden, function (facet) {
            return facet.name;
        });
        instant.search.addWidget({
            getConfiguration: function () {
                return {
                    facets: list,
                    disjunctiveFacets: list,
                };
            },
            init: function () {},
        });

        // Current refined values
        // var attributes = _.map(instant.facets.shown, function(facet) {
        //   return {
        //     name: facet.name,
        //     label: facet.title,
        //   };
        // });

        // instant.search.addWidget(
        //   instantsearch.widgets.currentRefinedValues({
        //     container: '.ais-current-refined-values-container',
        //     cssClasses: {
        //       root: 'ais-facet',
        //       header: 'ais-facet--header',
        //       body: 'ais-facet--body',
        //     },
        //     templates: {
        //       header: algolia.translations.selectedFilter,
        //       item: instant.templates.currentItem,
        //       clearAll: algolia.translations.clearAll,
        //     },
        //     onlyListedAttributes: true,
        //     attributes: attributes,
        //   })
        // );

        // RESET everything
        instant.search.addWidget(
            instantsearch.widgets.clearAll({
                container: '#clear-all',
                templates: {
                    link: 'Reset Filters'
                },
                autoHideContainer: false
            }),
        );
        
        instant.search.addWidget({
            init: function (opts) {
                var helper = opts.helper;

                $('#clear-all').on('click', function () {
                    if (localStorage.getItem('skus')) {
                        localStorage.removeItem('skus');
                        window.skus.value = [];
                    }
                    if ($(this).hasClass("collection-page")){
                        window.location.href = "/search";
                    }
                    if ($('.algolia-out-of-stock').hasClass('ais-facet--active')) {
                        $('.algolia-out-of-stock').removeClass('ais-facet--active');
                        helper.setQueryParameter('filters', '');
                    }
                    if ($('.algolia-in-stock').hasClass('ais-facet--active')) {
                        $('.algolia-in-stock').removeClass('ais-facet--active');
                        helper.setQueryParameter('filters', '');
                    }
                    
                    helper.search();

                    const parent = $('.filter_section.search_by_car');

                    if (!parent) return;

                    clearSelect('.filter_section.search_by_car', '.car-year-value.selected', 'Year');
                    clearSelect('.filter_section.search_by_car', '.car-brand-value.selected', 'Make');
                    clearSelect('.filter_section.search_by_car', '.car-model-value.selected', 'Model');
                    clearSelect('.filter_section.search_by_car', '.car-engine-value.selected', 'Engine');

                    function clearSelect(parent, target, defaultPlaceholder) {
                        $(parent).find(target).html(defaultPlaceholder);
                        $(parent).find('ul.car-brand').html('');
                        $(parent).find('ul.car-model').html('');
                        $(parent).find('ul.car-engine').html('');
                    }

                })
            },
        });

        // Facets
        _.forEach(instant.facets.widgets, function (widget) {
            instant.search.addWidget(
                instantsearch.widgets[widget.name](widget.params)
            );
        });

        // Hits
        instant.search.addWidget(
            instantsearch.widgets.hits({
                container: '.ais-hits-container',
                hitsPerPage: instant.hitsPerPage,
                templates: {
                    empty: instant.templates.empty,
                    item: instant.templates.product,
                },
                transformData: {
                    item: function (product) {
                        return Object.assign({}, product, {
                            _distinct: instant.distinct,
                            can_order: product.inventory_management !== 'shopify' ||
                                product.inventory_policy === 'continue' ||
                                product.inventory_quantity > 0,
                            translations: algolia.translations,
                            queryID: instant.search.helper.lastResults._rawResults[0].queryID,
                            productPosition: product.__hitIndex + 1,
                        });
                    },
                    empty: function (params) {
                        return Object.assign({}, params, {
                            translations: algolia.translations,
                        });
                    },
                },
            })
        );

        // Redirect to product on click
        instant.search.addWidget({
            init: function () {
                $('.ais-hits-container').on('click', '.ais-hit', function (e) {
                    var $this = $(this);
                    var dataHandle = $this.attr('data-handle');
                    var variant_id = $this.attr('data-variant-id');
                    var distinct = $this.attr('data-distinct');

                    var link = '/products/' + dataHandle;
                    if (distinct !== 'true') {
                        link += '?variant=' + variant_id;
                    }
                    if (algolia.config.analytics_enabled) {
                        algolia.clickTracker(e);
                    }
                    window.location.href = link;
                });
                $('.ais-hits-container').on('click', '.ais-hit a', function (e) {
                    e.stopPropagation();
                    if (algolia.config.analytics_enabled) {
                        algolia.clickTracker(e);
                    }
                });
            },
        });

        // Add to cart
        instant.search.addWidget({
            init: function () {
                $('.ais-hits-container').on('click', '.ais-hit--cart-button', function (
                    e
                ) {
                    e.stopPropagation();
                    var $this = $(this);
                    var formId = $this.attr('data-form-id');

                    if (formId) {
                        document.getElementById(formId).submit();
                    }
                });
            },
        });

        // No result actions
        instant.search.addWidget({
            init: function (opts) {
                $('.ais-hits-container').on(
                    'click',
                    '.ais-hit-empty--clear-filters',
                    function () {
                        var helper = opts.helper;
                        helper.clearTags();
                        _.forEach(instant.facets.list, function (facet) {
                            helper.clearRefinements(facet.name);
                        });
                        helper.search();
                    }
                );

                $('.ais-hits-container').on(
                    'click',
                    '.ais-hit-empty--clear-input',
                    function () {
                        opts.helper.setQuery('').search();
                        $('.ais-search-box--input')
                            .val('')
                            .focus();
                    }
                );
            },
        });

        // Pagination
        instant.search.addWidget(
            instantsearch.widgets.pagination({
                container: '.ais-pagination-container',
                padding: 3,
                maxPages: 10000,
                showFirst: true,
                showPrevious: true,
                showNext: true,
                showLast: true,
                labels: {
                    previous: '<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.14265 9.42861L1.85693 5.14289L6.14265 0.857178" stroke="#43464C" stroke-width="1.4"/></svg>',
                    next: '<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.857353 0.571394L5.14307 4.85711L0.857353 9.14282" stroke="#43464C" stroke-width="1.4"/></svg>',
                    first: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.77 9.56" width="12" height="11"><path d="M5.28,9.07,1,4.78,5.28.49" fill="none" stroke="#43464c" stroke-width="1.4"/><path d="M11.28,9.07,7,4.78,11.28.49" fill="none" stroke="#43464c" stroke-width="1.4"/></svg>',
                    last: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.77 9.56" width="12" height="11"><path d="M6.49.49l4.29,4.29L6.49,9.07" fill="none" stroke="#43464c" stroke-width="1.4"/><path d="M.49.49,4.78,4.78.49,9.07" fill="none" stroke="#43464c" stroke-width="1.4"/></svg>'
                },
                cssClasses: {
                    root: 'page-paging'
                }
            })
        );

        instant.search.on('render', function(){
            if (window.skus.value.length > 0 || instant.search.helper.getQuery().facetFilters != undefined || instant.search.helper.getQuery().numericFilters != undefined ) {
                $('#clear-all').css('display', 'flex');
            } else {
                if ( !$('#clear-all').hasClass("collection-page")){
                    $('#clear-all').css('display', 'none');
                }
                
            }

           /* console.log(instant.search.helper.getQuery())*/
            if (instant.search.helper.getQuery().query){
                $('.header__search').text('"' + instant.search.helper.getQuery().query + '"');
            } else if(window.location.href.indexOf("collections") != -1){
                var collection_name = location.href.split('collections/')[1].split('?')[0].replaceAll('-', ' ');
                $('.header__search').text('"' + collection_name + '"');
                /*console.log($('.header__search').text(collection_name))*/
            } else if(instant.search.helper.getQuery().facetFilters){
                console.log(instant.search.helper.getQuery().facetFilters)
                if (instant.search.helper.getQuery().facetFilters[1]){
                    var nameCategory = instant.search.helper.getQuery().facetFilters[1].toString().split(':')[1];
                    $('.header__search').text('"' + nameCategory + '"');
                }else{
                    var nameBrand = instant.search.helper.getQuery().facetFilters[0].toString().replaceAll('vendor:', ' ').replace(' ', '').split(':')[1];
                    if (nameBrand === ""){
                        $('.header__search').text("\"All Products\"")
                    }else{
                        $('.header__search').text('"' + nameBrand + '"');
                    }
                }
            } else{
                $('.header__search').text("\"All Products\"");
            }
        });

        // Main
        instant.search.start();

        $hiding.remove();
    });
})(window.algoliaShopify, window.instantsearch);




